/**
 * @description The primary color is your "brand" color, and is used across all interactive elements such as buttons, links, inputs, etc. This color can define the overall feel and can elicit emotion.
 */

const primary = {
  25: "#FEFDF0",
  50: "#FEFBE8",
  100: "#FEF7C3",
  200: "#FEDF89",
  300: "#FEC84B",
  400: "#FDB022",
  500: "#F79009",
  600: "#DC6803",
  700: "#B74C27",
  800: "#854A0E",
  900: "#713B12",
  950: "#60391C",
};

export default primary;
